module.exports = __webpack_public_path__ + "img/88.13cf20b3.jpg";